/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type CartCheckoutOfferButton_item$ref = any;
export type CartCheckoutOfferButton_item = {
    readonly serviceId: string | null;
    readonly " $refType": CartCheckoutOfferButton_item$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "CartCheckoutOfferButton_item",
    "type": "Item",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "serviceId",
            "args": null,
            "storageKey": null
        }
    ]
} as any);
(node as any).hash = '2f69e4959445a9443120e2d7dfa7a361';
export default node;
